import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Ghost, Users, Scale } from 'lucide-react';
const problems = [{
  icon: AlertTriangle,
  title: 'Credential Hemorrhage',
  description: 'Over 24 billion stolen credentials circulate the dark web. Reused passwords turn one breach into total exposure.',
  stat: '80% of breaches involve compromised passwords'
}, {
  icon: Ghost,
  title: 'Phantom Intrusions',
  description: 'Sophisticated attackers dwell undetected for months, silently exfiltrating sensitive data before you even notice.',
  stat: 'Average dwell time: 204 days'
}, {
  icon: Users,
  title: 'Social Engineering Siege',
  description: 'Phishing campaigns grow more convincing daily, bypassing traditional filters and exploiting human trust.',
  stat: '3.4 billion phishing emails sent daily'
}, {
  icon: Scale,
  title: 'Regulatory Crossfire',
  description: 'GDPR, NIS2, and evolving compliance mandates create a minefield of penalties for unprotected data.',
  stat: 'Fines up to €20M or 4% of revenue'
}];
export function ProblemsSection() {
  return <section id="threats" className="py-24 bg-[#0a0a0f] relative" data-id="element-133">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-134">
        <div className="text-center mb-16" data-id="element-135">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-136">
            THE THREAT LANDSCAPE IS{' '}
            <span className="text-[#ff3366]" data-id="element-137">UNFORGIVING</span>
          </h2>
          <p className="text-[#a0a0b0] max-w-2xl mx-auto" data-id="element-138">
            In the digital age, silence isn't safety. It's just a breach you
            haven't discovered yet.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-139">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-[#111118] border border-[#1e1e2e] p-6 rounded-lg hover:border-[#ff3366]/50 transition-colors group" data-id="element-140">
              <div className="mb-4 p-3 bg-[#ff3366]/10 w-fit rounded-full group-hover:bg-[#ff3366]/20 transition-colors" data-id="element-141">
                <problem.icon className="w-8 h-8 text-[#ff3366]" data-id="element-142" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3 font-mono" data-id="element-143">
                {problem.title}
              </h3>
              <p className="text-[#a0a0b0] text-sm mb-4 leading-relaxed" data-id="element-144">
                {problem.description}
              </p>
              <div className="pt-4 border-t border-[#1e1e2e]" data-id="element-145">
                <p className="text-[#ff3366] text-xs font-mono font-bold uppercase tracking-wider" data-id="element-146">
                  {problem.stat}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}